export default "__VITE_ASSET__CkvAZT8c__"